import createHttpClient from './httpClient'

const baseUrl = new URL('/api/v1/status', process.env.VUE_APP_INTERNAL_SERVICE_BASE_URL).href
const httpClient = createHttpClient(baseUrl)

const RESYNC_PATHS = {
  BuyerCampaign: '/buyer-campaigns/sync',
  Buyer: '/buyers/sync',
  Seller: '/sellers/sync',
  Category: '/categories/sync',
  SellerOfferRegistration: '/seller-offers/sync'
}

const SyncApi = {
  triggerResync(integrationType) {
    return httpClient.post(RESYNC_PATHS[integrationType])
  }
}

export default SyncApi
